export const CHART_TRANSITION_MS = 400;

export function pointTime(x) {
  return x instanceof Date ? x.getTime() : +x;
}

export function toPixelPoint(x, y, xScaleSet, yScaleSet) {
  return {
    xTime: pointTime(x),
    px: xScaleSet(x),
    py: yScaleSet(y),
  };
}

/** Bottom edge of the y-scale range in pixels (where points rise from on first draw). */
export function getBaselinePy(yScaleSet) {
  return yScaleSet.range()[0];
}
